import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { RootState } from "model";

export type ProjectDashboard = {
  guid: string;
  title: string;
};

export default class ProjectDashboardAPI {
  async getIds(): Promise<Array<string>> {
    const res = await fetch(
      `${
        process.env.REACT_APP_API_ENDPOINT
      }/${"v1"}/getDashboards/corporationsDashboardIds?dashboardType=CORPORATE`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt") || ""}`,
          "Content-Type": "application/json",
        },
      }
    );

    return (await res.json()) as Array<string>;
  }
}

const projectDashboardsApi = new ProjectDashboardAPI();

export const fetchAllProjectDashboards = createAsyncThunk(
  "projectDashboard/fetchIds",
  async () => {
    const fetchedDashboardIds = await projectDashboardsApi.getIds();
    return fetchedDashboardIds;
  }
);

const projectDashboardsAdapter = createEntityAdapter<ProjectDashboard>({
  selectId: (projectDashboard) => projectDashboard.guid,
});

export const {
  selectAll: selectAllProjectDashboards,
  selectById: selectProjectDashboardById,
  selectEntities: selectProjectDashboardsEntities,
  selectIds: selectProjectDashboardIds,
} = projectDashboardsAdapter.getSelectors(
  (state: RootState) => state.projectDashboards
);

type Status = "success" | "error" | null;
type LoadingState = "idle" | "pending";

export type projectDashboardsState = EntityState<ProjectDashboard> & {
  loading: LoadingState;
  error: null;
  status: Status;
};

const initialProjectDashboardsState: projectDashboardsState =
  projectDashboardsAdapter.getInitialState({
    loading: "idle",
    error: null,
    status: null,
  });

const projectDashboardsSlice = createSlice({
  name: "projectDashboards",
  initialState: initialProjectDashboardsState,
  reducers: {
    resetProjectDashboards: () => initialProjectDashboardsState,
  },
  extraReducers: {
    [fetchAllProjectDashboards.fulfilled.type]: (state, { payload }) => {
      for (const dashboardMetadata of payload.dashboards) {
        projectDashboardsAdapter.upsertOne(state, {
          guid: dashboardMetadata.guid,
          title: dashboardMetadata.title,
        });
      }
    },
  },
});

const { actions, reducer } = projectDashboardsSlice;

export const { resetProjectDashboards } = actions;
export const projectDashboardsReducer = reducer;
